import React from "react";
import { literToKiloliter } from "../utils/utils";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    BarElement,
    BarController,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import moment from "moment";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    BarController,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);

// const bgColor = ["rgba(99, 155, 245, 0.7)", "rgba(163, 199, 244, 0.7)"];
// const borderColor = ["rgba(147, 197, 253, 1)", "rgba(37, 99, 235, 1)"];

const bgColor = [
  "rgba(16, 112, 102, 0.7)",
  "rgba(76, 175, 143, 0.7)"
];

const borderColor = [
  "rgba(11, 90, 82, 1)",
  "rgba(16, 112, 102, 1)"
];

function HourlyBarChart({ dates, water_data, id }) {
    console.log("HourlyBarChart rendered with dates:", dates);

const labels = dates.map((date) => {
  // Extract start and end hour from your range (e.g., "13 - 14")
  const [start, end] = date.split("-").map((d) => d.trim());

  const start12 = moment(start, ["HH", "HH:mm", "HH:mm:ss"]).format("h");
  const end12 = moment(end, ["HH", "HH:mm", "HH:mm:ss"]).format("h");

  return `${start12} - ${end12}`;
});

    const data = {
        labels,
        datasets: [
            {
                data: water_data,
                backgroundColor: new Array(labels.length).fill(bgColor).flat(),
                borderColor: new Array(labels.length).fill(borderColor).flat(),
                borderWidth: 1,
            },
        ],
    };

    const ampmPluginInstance = {
        id: "ampmPluginBar",
        afterDraw: (chart) => {
            console.log("=== Bar Chart AM/PM Plugin Called ===");
            console.log("Original dates:", dates);

            const ctx = chart.ctx;
            const xScale = chart.scales.x;
            const chartArea = chart.chartArea;

            if (!xScale || !chartArea) {
                console.log("No xScale or chartArea");
                return;
            }

            console.log("Chart area:", chartArea);

            const yPos = chartArea.bottom + 45;

            let pmStartIndex = -1;
            dates.forEach((date, index) => {
                const dateStr = String(date).toLowerCase();
                if (dateStr.includes("pm") && pmStartIndex === -1) {
                    pmStartIndex = index;
                    console.log("Found PM at index:", index);
                }
            });

            if (pmStartIndex === -1) {
                console.log("No PM found in dates");
                return;
            }

            ctx.save();

            const leftPixel = chartArea.left;
            const rightPixel = chartArea.right;

            const totalLabels = dates.length;
            const barWidth = (rightPixel - leftPixel) / totalLabels;
            const pmStartPixel = leftPixel + (pmStartIndex * barWidth);

            console.log("Drawing lines - Left:", leftPixel, "PM Start:", pmStartPixel, "Right:", rightPixel);

            // ctx.strokeStyle = "#ff0000";
            ctx.strokeStyle = "#107066";
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.moveTo(leftPixel, yPos);
            ctx.lineTo(pmStartPixel, yPos);
            ctx.stroke();
            ctx.strokeStyle = "#0000ff";
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.moveTo(pmStartPixel, yPos);
            ctx.lineTo(rightPixel, yPos);
            ctx.stroke();

            ctx.font = "bold 12px Arial";
            ctx.textAlign = "center";
            ctx.textBaseline = "top";

            // ctx.fillStyle = "#ff0000";
            ctx.fillStyle = "#0b5a52";
            const amCenter = (leftPixel + pmStartPixel) / 2;
            ctx.fillText("AM", amCenter, yPos + 8);

            ctx.fillStyle = "#0000ff";
            const pmCenter = (pmStartPixel + rightPixel) / 2;
            ctx.fillText("PM", pmCenter, yPos + 8);

            console.log("Drew AM at", amCenter, "and PM at", pmCenter);

            ctx.restore();
        },
    };



    return (
        <div style={{ width: "100%", height: "300px" }}>
            <Bar
                id={id}
                data={data}
                plugins={[ampmPluginInstance, ChartDataLabels]}
                options={{
                    indexAxis: "x",
                    maintainAspectRatio: false,
                    responsive: true,
                    plugins: {
                        legend: { display: false },
                        tooltip: { enabled: false },
                        datalabels: {
                            display: true,
                            anchor: "end",
                            align: "top",
                            formatter: (value) => literToKiloliter(value),
                            font: { weight: "bold" },
                        },
                        ampmPluginBar: {},
                    },
                    layout: { padding: { left: 0, right: 0, top: 30, bottom: 40 } },
                    scales: {
                        y: {
  beginAtZero: true,
  ticks: {
    color: "#107066",
    font: { weight: "bold" }
  },
  title: {
    display: true,
    text: "Liters",
    color: "#107066",
    font: {
      size: 12,
      weight: "bold"
    }
  }
}
                    }
                }}

            />
        </div>
    );
}

export default HourlyBarChart;